import * as topojson from 'topojson-client'

import { BaseMap } from './base-map'
import { REGION_LEVELS } from './constants'
import ncCountyTopo from './topology/nc-counties.json'
import ncZipTopo from './topology/nc-zip.json'
import zipCodeCountyMapping from './topology/zip-counties-mapping.json'
import { TooltipContextProvider } from '../common/tooltip/tooltip.context'

// Format data for display
for (const zipCode in zipCodeCountyMapping) {
  zipCodeCountyMapping[zipCode] = zipCodeCountyMapping[zipCode].join(', ')
}

const DEFAULT_WIDTH = 1024
const isFirefox = navigator.userAgent.indexOf('Firefox') !== -1
const alignValue = isFirefox ? '-moz-center' : '-webkit-center'

export const NcMap = ({ regionLevel = REGION_LEVELS.COUNTY, width = 1024, height = width / (DEFAULT_WIDTH / 400), mapKeyPosition, ...props }) => {
  // Key is absolutely positioned within the div wrapper around the SVG.
  // Position is calculated based on container dimensions with the
  // scale being set to 1024x400px
  function getMapKeyPosition (regionLevel) {
    if (mapKeyPosition) {
      return mapKeyPosition
    } else if (regionLevel === REGION_LEVELS.COUNTY) {
      const legendProperties = width <= 887 ? {
        bottom: height / 6.666667, // When height is 550, this is bottom: 100px
        left: width / 6.826666667, // When width is 1024, this is left: 800px
        position: 'unset',
        textAlign: alignValue
      } : {
        bottom: height / 6.666667, // When height is 550, this is bottom: 100px
        left: width / 6.826666667 // When width is 1024, this is left: 800px
      }
      return legendProperties
    } else {
      const legendProperties = width <= 887 ? {
        bottom: height / 40, // When height is 550, this is bottom: 100px
        left: width / 102.4, // When width is 1024, this is left: 800px
        position: 'unset',
        textAlign: alignValue
      } : {
        bottom: height / 40, // When height is 550, this is bottom: 100px
        left: width / 102.4 // When width is 1024, this is left: 800px
      }
      return legendProperties
    }
  }

  return (
    <TooltipContextProvider>
      <BaseMap
        projectionType={'ncmap'}
        width={width}
        height={height}
        topology={getTopology(regionLevel)}
        mapRegionInfo={getRegionMapper(regionLevel)}
        layer={regionLevel === REGION_LEVELS.ZIP ? {
          topology: getTopology(REGION_LEVELS.COUNTY),
          label: 'County',
          data: zipCodeCountyMapping
        } : undefined}
        regionLabel={regionLevel}
        projectionProps={{
          scale: 6000,
          center: [ -80.15, 34.85 ]
        }}
        mapKeyPosition={getMapKeyPosition(regionLevel)}
        enableZoom={regionLevel === REGION_LEVELS.ZIP}
        {...props}
      />
    </TooltipContextProvider>
  )
}

function getTopology (regionLevel) {
  switch (regionLevel) {
    case REGION_LEVELS.COUNTY:
      return topojson.feature(ncCountyTopo, ncCountyTopo.objects.ncmap)
    case REGION_LEVELS.ZIP:
      return topojson.feature(ncZipTopo, ncZipTopo.objects['North_Carolina.geo'])
  }
}

function getRegionMapper (regionLevel) {
  switch (regionLevel) {
    case REGION_LEVELS.COUNTY:
      return (x) => ({
        code: x.properties.FIPS_integ,
        name: x.properties.county
      })
    case REGION_LEVELS.ZIP:
      return (x) => ({
        code: x.id,
        name: x.id
      })
  }
}
